<template>
  <div class="home">
    <!-- Верх страницы лежит на чёрном фоне: белая подложка в макете начинается
         только с секции «как попасть на чемпионат». -->
    <div class="home__top">
      <div class="home__inner">
        <SectionHero />
        <SectionAwards />
      </div>
    </div>
    <div class="home__bottom">
      <div class="home__inner">
        <SectionRegulations />
        <SectionVictory />
      </div>
    </div>
  </div>
</template>

<script setup>
import SectionHero from "@/components/SectionHero.vue";
import SectionAwards from "@/components/SectionAwards.vue";
import SectionRegulations from "@/components/SectionRegulations.vue";
import SectionVictory from "@/components/SectionVictory.vue";
</script>

<style lang="scss" scoped>
// Отступы по краям — на внешнем элементе, ограничение ширины — на внутреннем.
// Так же сделано в остальных блоках проекта (Header, AppFooter): padding снаружи,
// max-width с margin: 0 auto внутри.
.home__top {
  padding: 12px 12px 16px;

  @include md {
    padding: 16px 64px 32px;
  }
}

.home__bottom {
  background: var(--colorWhite);
  border-radius: var(--radiusOuter);
  // В макете на мобильном белая подложка — 336px с отступом 12px от краёв
  // и внутренним отступом 12px: контент получается 312px, как у секций.
  margin: 0 12px 12px;
  padding: 16px 12px;

  @include md {
    margin: 0;
    padding: 32px 64px;
  }
}

.home__inner {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: var(--widthContainer);
  margin: 0 auto;

  // Разрыв между «правилами» и «вызовом» на десктопе больше, чем между
  // остальными блоками — снято с макета.
  .home__bottom & {
    @include md {
      gap: 32px;
    }
  }
}
</style>
